import client from "./client";

export interface SiteSettings {
  free_cancel_days: number;
  free_cancel_hour: number;
  rules_text: string;
  rules_image_url: string | null;
  schedule_text: string;
  schedule_image_url: string | null;
  info_text: string;
  info_image_url: string | null;
  announce_text: string;
  announce_image_url: string | null;
  announce_hours: number;
  postscript_text: string;
  postscript_image_url: string | null;
  postscript_hour: number;
  pickup_banner_title: string;
  pickup_banner_text: string;
}

export interface SettingsUpdate {
  free_cancel_days: number;
  free_cancel_hour: number;
  rules_text: string;
  schedule_text: string;
  info_text: string;
  announce_text: string;
  announce_hours: number;
  postscript_text: string;
  postscript_hour: number;
  pickup_banner_title: string;
  pickup_banner_text: string;
}

export async function getSettings(): Promise<SiteSettings> {
  const res = await client.get<SiteSettings>("/settings/");
  return res.data;
}

export interface ScheduleInfo {
  schedule_text: string;
  schedule_image_url: string | null;
}

export async function getSchedule(): Promise<ScheduleInfo> {
  const res = await client.get<ScheduleInfo>("/settings/schedule");
  return res.data;
}

export interface PickupBanner {
  title: string;
  text: string;
}

/** Плашка «Как забрать заказ?» в шапке каталога. */
export async function getPickupBanner(): Promise<PickupBanner> {
  const res = await client.get<PickupBanner>("/settings/pickup-banner");
  return res.data;
}

export async function updateSettings(
  data: SettingsUpdate,
): Promise<SiteSettings> {
  const res = await client.put<SiteSettings>("/settings/", data);
  return res.data;
}

export async function uploadSettingsImage(
  section: "rules" | "schedule" | "info" | "announce" | "postscript",
  file: File,
): Promise<SiteSettings> {
  const formData = new FormData();
  formData.append("file", file);
  const res = await client.post<SiteSettings>(
    `/settings/image/${section}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return res.data;
}

export async function deleteSettingsImage(
  section: "rules" | "schedule" | "info" | "announce" | "postscript",
): Promise<SiteSettings> {
  const res = await client.delete<SiteSettings>(
    `/settings/image/${section}`,
  );
  return res.data;
}

export async function publishInfoSection(
  section: "rules" | "schedule" | "info",
): Promise<{ ok: boolean }> {
  const res = await client.post<{ ok: boolean }>(
    `/settings/publish-info/${section}`,
  );
  return res.data;
}
